import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Icon,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/core";
import React, { useState } from "react";
import CardFooter from "../CardFooter";

const CompanyDetails = ({
  handleEachChange,
  organisation,
  index,
  designation,
  responsibilities,
  fromMM,
  fromYY,
  toMM,
  toYY,
}) => (
  <>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>Organisation</FormLabel>
        <Input
          value={organisation}
          onChange={(e) => {
            organisation = e.target.value;
            handleEachChange(index, e.target.value, "organisation");
          }}
          placeholder="Company Name"
        />
      </FormControl>
      <FormControl>
        <FormLabel>Designation</FormLabel>
        <Input placeholder="Lorem Ipsum" />
      </FormControl>
    </SimpleGrid>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>Responsibilities</FormLabel>
        <Textarea placeholder="Tell us about your work" />
      </FormControl>
    </SimpleGrid>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>From</FormLabel>
        <Stack isInline>
          <Select placeholder="MM">
            <option>1</option>
            <option>2</option>
          </Select>
          <Select placeholder="YY">
            <option>00</option>
            <option>02</option>
          </Select>
        </Stack>
      </FormControl>
      <FormControl>
        <FormLabel>To</FormLabel>
        <Stack isInline>
          <Select placeholder="MM">
            <option>01</option>
            <option>02</option>
          </Select>
          <Select placeholder="YY">
            <option>00</option>
            <option>02</option>
          </Select>
        </Stack>
      </FormControl>
    </SimpleGrid>
  </>
);

function ProfessionalDetails() {
  const demoCompanyInfo = {
    organisation: "",
    designation: "",
    responsibilities: "",
    fromMM: "",
    fromYY: "",
    toMM: "",
    toYY: "",
  };
  const [companyInfo, setCompanyInfo] = useState([demoCompanyInfo]);
  const addCompany = () => {
    setCompanyInfo([...companyInfo, demoCompanyInfo]);
  };
  // const handleInfoChange = (index, newInfo) => {
  //     // const {organisation, designation, responsibilities, fromMM, fromYY, toMM, toYY} = newInfo;
  //     companyInfo[index] = newInfo;
  //     setCompanyInfo(companyInfo);
  // }
  const handleEachChange = (index, newVal, prop) => {
    companyInfo[index][prop] = newVal;
  };
  // console.log(companyInfo)
  return (
    <Box p="10">
      <Text fontSize="2xl">Professional Details</Text>
      <Divider />
      {companyInfo.map((each, i) => (
        <CompanyDetails
          key={each.organisation}
          index={i}
          handleEachChange={handleEachChange}
          organisation={each.organisation}
          designation={each.designation}
          responsibilities={each.responsibilities}
          fromMM={each.fromMM}
          fromYY={each.fromYY}
          toMM={each.toMM}
          toYY={each.toYY}
        />
      ))}
      <Button padding="0" boxShadow="lg" rounded="full" onClick={addCompany}>
        <Icon name="add" />
      </Button>
      <CardFooter />
    </Box>
  );
}

export default ProfessionalDetails;
